export const NAMESPACE = 'selected-users';

export const CLEAR_USERS_SELECTION = `${NAMESPACE}/CLEAR_USERS_SELECTION`;
export const TOGGLE_USER_SELECTION = `${NAMESPACE}/TOGGLE_USER_SELECTION`;
